import transferServices from '@/api/transferServices';
import { RootState } from '@/app/store';
import { DefferedTransfer } from '@/interfaces/transfer';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

interface InternalState {
  defferedTransfers: DefferedTransfer[];
  totalElements: number;
  totalPages: number;
  recordsSize: number;
  number: number;
  loading: boolean;
  error: string;
}

const initialState: InternalState = {
  defferedTransfers: [],
  totalElements: 0,
  totalPages: 0,
  recordsSize: 0,
  number: 0,
  loading: false,
  error: '',
};

export const fetchDefferedTransfers = createAsyncThunk('defferedTransfers/fetch', async (params: any) => {
  return transferServices.loadTransfers(params);
});

export const defferedTransfersSlice = createSlice({
  name: 'defferedTransfers',
  initialState,
  reducers: {
    clearDeferredTransfers: () => initialState,
  },

  extraReducers: builder => {
    builder.addCase(fetchDefferedTransfers.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchDefferedTransfers.fulfilled, (state, action) => {
      const {
        payload: { data, size, totalElements, totalPages, number },
      } = action;
      state.defferedTransfers = data;
      state.recordsSize = size;
      state.totalElements = totalElements;
      state.totalPages = totalPages;
      state.number = number + 1;
      state.loading = false;
    });

    builder.addCase(fetchDefferedTransfers.rejected, state => {
      state.loading = false;
      state.error = 'Error';
    });
  },
});

export const selectDefferedTransfers = (state: RootState) => state.defferedTransfer;
export const { clearDeferredTransfers } = defferedTransfersSlice.actions;
export default defferedTransfersSlice.reducer;
